import Services from "services";

class LaporanHargaPerkiraanSendiriApi {
  getPage(params) {
    return Services.get("/harga_perkiraan_sendiri/page", { params });
  }
}

export default new LaporanHargaPerkiraanSendiriApi();
